/* ============================================================
   ZYKAZ CART DRAWER FIX
   Fixes: X button, backdrop click, and Escape key not working
   when drawer is opened via Add to Cart button.

   Root cause: when opened via ADD_TO_CART, the theme calls
   o.focus() on the drawer element which steals focus away from
   the X button mid-click (mousedown → focus stolen → mouseup
   never fires on button → click never triggers).
   ============================================================ */

(function () {
  'use strict';

  function closeDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  function patchCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    if (drawer.dataset.zykazPatched) return;
    drawer.dataset.zykazPatched = 'true';

    // ── FIX 1: X close button ─────────────────────────────────
    // The theme's o.focus() call after opening steals focus mid-click
    // on the X button, so the click event never fires.
    // We use mousedown (fires before focus moves) to reliably catch it.
    drawer.addEventListener('mousedown', function (e) {
      var btn = e.target.closest('.js-cart-drawer-close');
      if (btn) {
        // Prevent the focus from moving away mid-click
        e.preventDefault();
        closeDrawer();
      }
    });

    // ── FIX 2: Backdrop / overlay click ───────────────────────
    // When opened via Add to Cart, pointer-events on the underlay
    // may not be set correctly. We handle it at the drawer level.
    drawer.addEventListener('mousedown', function (e) {
      if (e.target.id === 'cart-drawer-underlay' ||
          e.target.classList.contains('u-backdrop')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    // ── FIX 3: Escape key ─────────────────────────────────────
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('active')) {
        closeDrawer();
      }
    });

    // ── FIX 4: Ensure underlay pointer-events are always active
    var observer = new MutationObserver(function () {
      var underlay = document.getElementById('cart-drawer-underlay');
      if (!underlay) return;
      var isActive = drawer.classList.contains('active');
      underlay.style.pointerEvents = isActive ? 'auto' : 'none';
      underlay.style.cursor = isActive ? 'pointer' : 'default';
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchCartDrawer);
  } else {
    patchCartDrawer();
  }

  window.addEventListener('shopify:section:load', function () {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) delete drawer.dataset.zykazPatched;
    patchCartDrawer();
  });

})();
